// Service detail metadata — slug-indexed
// Long descriptions, gallery (stock images themed for each service) and SEO meta.
// When user provides real photos, swap the `gallery` URLs.

export const SERVICE_SLUGS = [
  "assistencia-tecnica",
  "televisao",
  "comunicacoes",
  "informatica",
  "seguranca-cctv",
];

// Common stock galleries (curated)
const TECH_GALLERY = [
  "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=1400&q=80",
  "https://images.unsplash.com/photo-1581092921461-eab62e97a780?auto=format&fit=crop&w=1400&q=80",
  "https://images.unsplash.com/photo-1603732551681-2e91159b9dc2?auto=format&fit=crop&w=1400&q=80",
  "https://images.unsplash.com/photo-1573164574572-cb89e39749b4?auto=format&fit=crop&w=1400&q=80",
];

// Towers / masts gallery — generated locally via Gemini Nano Banana
const TOWERS_GALLERY = [
  "/towers/tower-6m.png",
  "/towers/tower-12m.png",
  "/towers/tower-24m.png",
  "/towers/tower-30m.png",
  "/towers/tower-residential.png",
  "/towers/tower-commercial.png",
  "/towers/tower-mining.png",
  "/towers/tower-broadcast.png",
];

const TV_GALLERY = [
  "https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?auto=format&fit=crop&w=1400&q=80",
  "https://images.unsplash.com/photo-1578945511419-6045edb81f06?auto=format&fit=crop&w=1400&q=80",
  "https://images.unsplash.com/photo-1571171637578-41bc2dd41cd2?auto=format&fit=crop&w=1400&q=80",
  "https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=1400&q=80",
];

const COMMS_GALLERY = [
  "https://images.unsplash.com/photo-1519861531473-9200262188bf?auto=format&fit=crop&w=1400&q=80",
  "https://images.unsplash.com/photo-1497436072909-60f360e1d4b1?auto=format&fit=crop&w=1400&q=80",
  "https://images.unsplash.com/photo-1614064641938-3bbee52942c7?auto=format&fit=crop&w=1400&q=80",
  "https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=1400&q=80",
];

const IT_GALLERY = [
  "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1400&q=80",
  "https://images.unsplash.com/photo-1551808525-51a94da548ce?auto=format&fit=crop&w=1400&q=80",
  "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=1400&q=80",
  "https://images.unsplash.com/photo-1484557985045-edf25e08da73?auto=format&fit=crop&w=1400&q=80",
];

export const servicesData = {
  "assistencia-tecnica": {
    key: "assistance",
    hero: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?auto=format&fit=crop&w=2000&q=80",
    gallery: TECH_GALLERY,
    icon: "Wrench",
    highlights: {
      pt: [
        "Intervenções preventivas e correctivas",
        "Diagnóstico no local em Luanda e Província",
        "Peças originais das marcas representadas",
        "Relatórios técnicos e SLA personalizados",
      ],
      en: [
        "Preventive and corrective interventions",
        "On-site diagnostics in Luanda and provinces",
        "Genuine parts from represented brands",
        "Technical reports and tailored SLAs",
      ],
      es: [
        "Intervenciones preventivas y correctivas",
        "Diagnóstico in situ en Luanda y provincias",
        "Piezas originales de marcas representadas",
        "Informes técnicos y SLA personalizados",
      ],
    },
    longDesc: {
      pt: "A nossa equipa de assistência técnica actua em toda a infra-estrutura crítica de telecomunicações e informática — do diagnóstico ao reparo, com peças originais e registo completo de cada intervenção. Garantimos disponibilidade, tempos de resposta acordados e continuidade operacional para empresas, condomínios e entidades públicas.",
      en: "Our technical assistance team covers your entire telecom and IT critical infrastructure — from diagnostics to repair, with genuine parts and full traceability. We guarantee availability, agreed response times and operational continuity for companies, condominiums and public entities.",
      es: "Nuestro equipo de asistencia técnica cubre toda la infraestructura crítica de telecom e informática — del diagnóstico a la reparación, con piezas originales y trazabilidad completa. Garantizamos disponibilidad, tiempos de respuesta y continuidad operacional para empresas, condominios y entidades públicas.",
    },
    seo: {
      pt: {
        title: "Assistência Técnica · DSTV, VSAT, Redes e Centrais — TVCabSat Luanda",
        description:
          "Assistência técnica especializada em sistemas DSTV, redes de telecomunicações, centrais telefónicas, VSATs e sistemas de informática em Angola.",
      },
      en: {
        title: "Technical Assistance · DSTV, VSAT, Networks & PBX — TVCabSat Luanda",
        description:
          "Specialized technical assistance for DSTV systems, telecom networks, PBX, VSATs and IT systems in Angola.",
      },
      es: {
        title: "Asistencia Técnica · DSTV, VSAT, Redes y Centralitas — TVCabSat Luanda",
        description:
          "Asistencia técnica especializada en DSTV, redes telecom, centralitas, VSAT y sistemas IT en Angola.",
      },
    },
  },
  televisao: {
    key: "television",
    hero: "https://images.unsplash.com/photo-1536440136628-849c177e76a1?auto=format&fit=crop&w=2000&q=80",
    gallery: TV_GALLERY,
    icon: "Television",
    highlights: {
      pt: [
        "Projecto e montagem chave-na-mão",
        "Distribuição TV para condomínios",
        "Monitores LED e LCD com garantia",
        "Instalação DSTV com parabólica calibrada",
      ],
      en: [
        "Turn-key design and installation",
        "TV distribution for condominiums",
        "LED and LCD monitors with warranty",
        "DSTV install with calibrated dish",
      ],
      es: [
        "Diseño e instalación llave en mano",
        "Distribución TV para condominios",
        "Monitores LED y LCD con garantía",
        "Instalación DSTV con parabólica calibrada",
      ],
    },
    longDesc: {
      pt: "Projectamos, instalamos e mantemos sistemas de recepção e distribuição de televisão para residências, empreendimentos e edifícios multifamiliares. Com parabólicas calibradas, amplificadores dimensionados e cablagem profissional, entregamos sinal estável — canal por canal, apartamento por apartamento.",
      en: "We design, install and maintain TV reception and distribution systems for homes, developments and multifamily buildings. With calibrated dishes, sized amplifiers and professional cabling, we deliver a stable signal — channel by channel, unit by unit.",
      es: "Diseñamos, instalamos y mantenemos sistemas de recepción y distribución de TV para residencias, desarrollos y edificios multifamiliares. Con parabólicas calibradas, amplificadores dimensionados y cableado profesional, entregamos señal estable — canal por canal, unidad por unidad.",
    },
    seo: {
      pt: {
        title: "Monitores HD · DSTV e Distribuição TV para Condomínios — TVCabSat",
        description:
          "Comercialização de monitores LED e LCD, montagem de sistemas DSTV e distribuição de sinal TV para condomínios em Luanda, Angola.",
      },
      en: {
        title: "HD Monitors · DSTV & Condominium TV Distribution — TVCabSat",
        description:
          "LED and LCD monitor sales, DSTV installation and TV signal distribution for condominiums in Luanda, Angola.",
      },
      es: {
        title: "Monitores HD · DSTV y Distribución TV para Condominios — TVCabSat",
        description:
          "Venta de monitores LED y LCD, instalación DSTV y distribución de señal TV para condominios en Luanda, Angola.",
      },
    },
  },
  comunicacoes: {
    key: "communications",
    hero: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=2000&q=80",
    gallery: COMMS_GALLERY,
    icon: "Broadcast",
    highlights: {
      pt: [
        "Rádios e repetidores MOTOROLA",
        "Centrais telefónicas INTELBRAS e ALCATEL",
        "VSATs para locais remotos",
        "Projecto, licenciamento e operação",
      ],
      en: [
        "MOTOROLA radios & repeaters",
        "INTELBRAS and ALCATEL PBX",
        "VSATs for remote locations",
        "Design, licensing and operation",
      ],
      es: [
        "Radios y repetidores MOTOROLA",
        "Centralitas INTELBRAS y ALCATEL",
        "VSAT para ubicaciones remotas",
        "Proyecto, licencias y operación",
      ],
    },
    longDesc: {
      pt: "Comunicações profissionais para equipas no terreno, escritórios e locais remotos: rádio bidireccional, telefonia IP/tradicional, e ligações VSAT onde a fibra não chega. Da especificação à operação assistida, entregamos soluções robustas, compatíveis com o quadro regulatório angolano.",
      en: "Professional communications for field teams, offices and remote sites: two-way radio, IP/traditional telephony, and VSAT where fiber can't reach. From specification to assisted operation, we deliver robust solutions compliant with the Angolan regulatory framework.",
      es: "Comunicaciones profesionales para equipos en terreno, oficinas y sitios remotos: radio bidireccional, telefonía IP/tradicional y VSAT donde la fibra no llega. De la especificación a la operación asistida, entregamos soluciones robustas conformes al marco angoleño.",
    },
    seo: {
      pt: {
        title: "Comunicações · MOTOROLA, INTELBRAS, ALCATEL & VSAT — TVCabSat",
        description:
          "Rádios, repetidores, centrais telefónicas e soluções VSAT para empresas e operações críticas em Angola.",
      },
      en: {
        title: "Communications · MOTOROLA, INTELBRAS, ALCATEL & VSAT — TVCabSat",
        description:
          "Radios, repeaters, PBX and VSAT solutions for companies and critical operations in Angola.",
      },
      es: {
        title: "Comunicaciones · MOTOROLA, INTELBRAS, ALCATEL & VSAT — TVCabSat",
        description:
          "Radios, repetidores, centralitas y soluciones VSAT para empresas y operaciones críticas en Angola.",
      },
    },
  },
  informatica: {
    key: "it",
    hero: "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=2000&q=80",
    gallery: IT_GALLERY,
    icon: "Desktop",
    highlights: {
      pt: [
        "Redes estruturadas cat. 6/6A e fibra",
        "Wireless outdoor/indoor para dados",
        "Computadores e periféricos",
        "Internet point-to-point e backup",
      ],
      en: [
        "Structured networks cat. 6/6A and fiber",
        "Outdoor/indoor wireless for data",
        "Computers and peripherals",
        "Point-to-point internet & backup",
      ],
      es: [
        "Redes estructuradas cat. 6/6A y fibra",
        "Wireless outdoor/indoor para datos",
        "Computadoras y periféricos",
        "Internet punto a punto y respaldo",
      ],
    },
    longDesc: {
      pt: "Da cablagem estruturada à ligação wireless de longa distância, desenhamos redes fiáveis que sustentam a operação diária. Fornecemos, instalamos e configuramos computadores, pontos de acesso e switches para escritórios, lojas, canteiros de obra e unidades industriais.",
      en: "From structured cabling to long-range wireless links, we design reliable networks that support daily operations. We supply, install and configure computers, access points and switches for offices, stores, construction sites and industrial units.",
      es: "Del cableado estructurado a enlaces wireless de larga distancia, diseñamos redes fiables que sostienen la operación diaria. Suministramos, instalamos y configuramos computadoras, puntos de acceso y switches para oficinas, comercios, obras y unidades industriales.",
    },
    seo: {
      pt: {
        title: "Informática · Redes, Wireless e Computadores — TVCabSat Angola",
        description:
          "Redes estruturadas, sistemas wireless, computadores e soluções de Internet para empresas em Luanda e Angola.",
      },
      en: {
        title: "IT · Networks, Wireless & Computers — TVCabSat Angola",
        description:
          "Structured networks, wireless systems, computers and internet solutions for companies in Luanda and Angola.",
      },
      es: {
        title: "Informática · Redes, Wireless y Computadoras — TVCabSat Angola",
        description:
          "Redes estructuradas, sistemas wireless, computadoras y soluciones de Internet para empresas en Luanda y Angola.",
      },
    },
  },
  "mastros-torres": {
    key: "towers",
    hero: "/towers/tower-30m.png",
    gallery: TOWERS_GALLERY,
    icon: "CellTower",
    highlights: {
      pt: [
        "Mastros galvanizados de 6m a 12m",
        "Torres treliçadas autoportantes 15m a 30m",
        "Torres estaiadas (guyed) para zonas remotas",
        "Bases em betão armado e ancoragens",
        "Instalação de antenas, dishes e cablagem",
        "Iluminação de obstáculos e pára-raios",
      ],
      en: [
        "Galvanised masts from 6m to 12m",
        "Self-supporting lattice towers 15m to 30m",
        "Guyed towers for remote sites",
        "Reinforced concrete bases and anchors",
        "Antenna, dish and cable installation",
        "Obstruction lighting and lightning protection",
      ],
      es: [
        "Mástiles galvanizados de 6m a 12m",
        "Torres reticuladas autoportantes de 15m a 30m",
        "Torres con vientos para sitios remotos",
        "Bases de hormigón armado y anclajes",
        "Instalación de antenas, dishes y cableado",
        "Balizamiento y pararrayos",
      ],
    },
    longDesc: {
      pt: "Projectamos e construímos mastros e torres de 6 a 30 metros para instalação de equipamentos de telecomunicações, broadcast e VSAT — em ambiente residencial, comercial, industrial e mineiro. Da memória de cálculo estrutural ao memorial fotográfico de obra, entregamos infra-estrutura preparada para suportar antenas, dishes e cargas de vento da costa angolana às províncias do interior.",
      en: "We design and build masts and towers from 6 to 30 metres for telecom, broadcast and VSAT equipment — across residential, commercial, industrial and mining sites. From structural calculation to photographic build report, we deliver infrastructure ready to carry antennas, dishes and wind loads from the Angolan coast to inland provinces.",
      es: "Diseñamos y construimos mástiles y torres de 6 a 30 metros para equipos de telecom, broadcast y VSAT — en entornos residenciales, comerciales, industriales y mineros. De la memoria de cálculo estructural al informe fotográfico de obra, entregamos infraestructura preparada para soportar antenas, dishes y cargas de viento de la costa angoleña al interior.",
    },
    seo: {
      pt: {
        title: "Mastros e Torres · Construção 6m a 30m — TVCabSat Angola",
        description:
          "Construção de mastros e torres autoportantes e estaiadas de 6 a 30 metros para instalação de antenas, VSATs e equipamentos de telecomunicações em Angola.",
      },
      en: {
        title: "Masts & Towers · 6m to 30m Construction — TVCabSat Angola",
        description:
          "Construction of self-supporting and guyed masts and towers from 6 to 30 metres for antenna, VSAT and telecom equipment installation in Angola.",
      },
      es: {
        title: "Mástiles y Torres · Construcción 6m a 30m — TVCabSat Angola",
        description:
          "Construcción de mástiles y torres autoportantes y con vientos de 6 a 30 metros para antenas, VSAT y equipos de telecomunicaciones en Angola.",
      },
    },
  },
  "seguranca-cctv": {
    key: "security",
    hero: "/security/cctv-hero.png",
    gallery: [
      "/security/cctv-hero.png",
      "/security/cctv-ip-camera.png",
      "/security/cctv-ai-recognition.png",
      "/security/cctv-nvr-rack.png",
    ],
    icon: "VideoCamera",
    highlights: {
      pt: [
        "Monitorização remota em tempo real",
        "Maior precisão na deteção de eventos",
        "Integração com outros sistemas de segurança",
        "Consulta rápida de imagens gravadas",
      ],
      en: [
        "Real-time remote monitoring",
        "Higher accuracy in event detection",
        "Integration with other security systems",
        "Fast playback of recorded footage",
      ],
      es: [
        "Monitorización remota en tiempo real",
        "Mayor precisión en la detección de eventos",
        "Integración con otros sistemas de seguridad",
        "Consulta rápida de imágenes grabadas",
      ],
    },
    items: {
      pt: [
        "Câmaras analógicas ou IP — alta qualidade de imagem",
        "Inteligência Artificial: reconhecimento facial e leitura de matrículas",
        "Gravação contínua NVR / DVR com armazenamento seguro",
        "Aplicação móvel para visualização remota",
        "Integração com alarme, controlo de acessos e cerca eléctrica",
        "Manutenção preventiva e suporte 24/7",
      ],
      en: [
        "Analog or IP cameras — high image quality",
        "Artificial Intelligence: facial recognition and licence-plate reading",
        "Continuous NVR / DVR recording with secure storage",
        "Mobile app for remote viewing",
        "Integration with alarm, access control and electric fence",
        "Preventive maintenance and 24/7 support",
      ],
      es: [
        "Cámaras analógicas o IP — alta calidad de imagen",
        "Inteligencia Artificial: reconocimiento facial y lectura de matrículas",
        "Grabación continua NVR / DVR con almacenamiento seguro",
        "App móvil para visualización remota",
        "Integración con alarma, control de accesos y cerca eléctrica",
        "Mantenimiento preventivo y soporte 24/7",
      ],
    },
    longDesc: {
      pt: "O CCTV (Circuito Fechado de Televisão) é a base de qualquer estratégia eficaz de monitorização. Permite a observação remota de espaços, garantindo proteção contínua para empresas, residências ou instituições. Projetamos sistemas com câmaras analógicas ou IP, funcionalidades avançadas de Inteligência Artificial (reconhecimento facial, leitura automática de matrículas) e gravação contínua em NVR/DVR, integráveis com alarme, controlo de acessos e outros sistemas de segurança — para uma vigilância inteligente, proativa e fiável.",
      en: "CCTV (Closed-Circuit Television) is the backbone of any effective monitoring strategy. It enables remote observation of premises and continuous protection for businesses, homes and institutions. We design systems with analog or IP cameras, advanced AI features (facial recognition, automatic licence-plate reading) and continuous NVR/DVR recording, integrable with alarms, access control and other security systems — for intelligent, proactive and reliable surveillance.",
      es: "El CCTV (Circuito Cerrado de Televisión) es la columna vertebral de cualquier estrategia eficaz de monitorización. Permite la observación remota de espacios y la protección continua de empresas, residencias e instituciones. Diseñamos sistemas con cámaras analógicas o IP, funcionalidades avanzadas de Inteligencia Artificial (reconocimiento facial, lectura automática de matrículas) y grabación continua en NVR/DVR, integrables con alarma, control de accesos y otros sistemas de seguridad — para una vigilancia inteligente, proactiva y fiable.",
    },
    seo: {
      pt: {
        title: "Segurança & CCTV · Sistemas de Monitorização — TVCabSat Angola",
        description:
          "Instalação e manutenção de sistemas CCTV (câmaras IP/analógicas), NVR/DVR e reconhecimento facial em Luanda, Angola.",
      },
      en: {
        title: "Security & CCTV · Monitoring Systems — TVCabSat Angola",
        description:
          "Installation and maintenance of CCTV systems (IP / analog cameras), NVR/DVR and facial recognition in Luanda, Angola.",
      },
      es: {
        title: "Seguridad & CCTV · Sistemas de Monitorización — TVCabSat Angola",
        description:
          "Instalación y mantenimiento de sistemas CCTV (cámaras IP/analógicas), NVR/DVR y reconocimiento facial en Luanda, Angola.",
      },
    },
  },
};

// Labels for gallery section / breadcrumb / CTA
export const servicePageStrings = {
  pt: {
    breadcrumb_home: "Início",
    breadcrumb_services: "Serviços",
    highlights_title: "Em destaque",
    scope_title: "O que cobrimos",
    gallery_title: "Galeria",
    gallery_note: "Imagens ilustrativas · as fotos dos nossos projectos serão adicionadas em breve",
    cta_title: "Precisa de uma proposta?",
    cta_desc: "Descreva o seu projecto — respondemos com orçamento em horário comercial.",
    cta_btn: "Solicitar Orçamento",
    other_services: "Outros serviços",
    back: "Voltar",
  },
  en: {
    breadcrumb_home: "Home",
    breadcrumb_services: "Services",
    highlights_title: "Highlights",
    scope_title: "What we cover",
    gallery_title: "Gallery",
    gallery_note: "Illustrative images · photos of our real projects will be added soon",
    cta_title: "Need a proposal?",
    cta_desc: "Tell us about your project — we reply with a quote during business hours.",
    cta_btn: "Request a Quote",
    other_services: "Other services",
    back: "Back",
  },
  es: {
    breadcrumb_home: "Inicio",
    breadcrumb_services: "Servicios",
    highlights_title: "Destacados",
    scope_title: "Lo que cubrimos",
    gallery_title: "Galería",
    gallery_note: "Imágenes ilustrativas · las fotos de nuestros proyectos reales se añadirán pronto",
    cta_title: "¿Necesitas una propuesta?",
    cta_desc: "Cuéntanos tu proyecto — respondemos con presupuesto en horario comercial.",
    cta_btn: "Solicitar presupuesto",
    other_services: "Otros servicios",
    back: "Volver",
  },
};
